/**
 * Route path constants.
 *
 * Every link in the application references these instead of hardcoded strings,
 * so renaming a URL is a one-line change and the navigation data, the
 * sitemap, and the tests can never drift apart.
 *
 * The site is deliberately two pages. The assistant and the inquiry form are
 * part of those pages rather than separate routes, which keeps every visitor
 * path reachable in a single click.
 */
export const ROUTES = {
  home: '/',
  services: '/services',
};

/** All routes that are fully public and appear in the sitemap. */
export const PUBLIC_MARKETING_ROUTES = [ROUTES.home, ROUTES.services];

/**
 * Id of the inquiry-form section on the Services page.
 *
 * The header CTA and the closing call to action both deep link to it, so the
 * anchor is defined once here and referenced through `inquiryHref` below.
 * ScrollManager is what scrolls to it on a client-side navigation.
 */
export const INQUIRY_ANCHOR_ID = 'inquiry';

/** Deep link to the inquiry form, used by every "get started" link on the site. */
export const inquiryHref = `${ROUTES.services}#${INQUIRY_ANCHOR_ID}`;

/**
 * Id of the capabilities section on the Services page.
 *
 * The hero's secondary action points at the list rather than the top of a
 * different page, so a visitor who wants to read before they talk lands on the
 * capabilities themselves. Defined once here for the same reason as the inquiry
 * anchor above.
 */
export const CAPABILITIES_ANCHOR_ID = 'capabilities';

/** Deep link to the capabilities list, used by the hero's secondary action. */
export const capabilitiesHref = `${ROUTES.services}#${CAPABILITIES_ANCHOR_ID}`;

export default ROUTES;
